import { ChevronDown, Mic } from 'lucide-react';
import { IconButton } from '../icon-button/icon-button.tsx';
import {
  Menu,
  MenuContent,
  MenuGroup,
  MenuGroupLabel,
  MenuRadioGroup,
  MenuRadioItem,
  MenuTrigger,
} from '../menu/menu.tsx';
import type { ChatComposerDictation } from './chat-composer-types.ts';

interface ChatComposerDictateProps {
  dictation: ChatComposerDictation;
  disabled: boolean;
  /** On the microphone that starts a recording. */
  startLabel: string;
  /** On the chevron beside it. */
  optionsLabel: string;
  /** Above the list of microphones. */
  microphoneLabel: string;
}

/** The microphone that starts a recording, and the chevron that picks which one. */
export function ChatComposerDictate({
  dictation,
  disabled,
  startLabel,
  optionsLabel,
  microphoneLabel,
}: ChatComposerDictateProps) {
  return (
    <div className='flex shrink-0 items-center'>
      <IconButton
        aria-label={startLabel}
        size='sm'
        disabled={disabled}
        onClick={dictation.onStart}
      >
        <Mic size={15} aria-hidden='true' />
      </IconButton>

      {/*
        Opening the menu is when the microphone is asked for: the names in it
        exist only for a page that has been granted one, so the question comes
        when the list is about to be read, not after something was said into it.
      */}
      <Menu
        onOpenChange={(open) => {
          if (open) {
            dictation.onOpenOptions();
          }
        }}
      >
        <MenuTrigger
          render={<IconButton aria-label={optionsLabel} size='sm' className='w-4' />}
          disabled={disabled}
        >
          <ChevronDown size={13} aria-hidden='true' />
        </MenuTrigger>
        <MenuContent side='top' align='end' className='min-w-56'>
          <MenuGroup>
            <MenuGroupLabel>{microphoneLabel}</MenuGroupLabel>
            {/* Nothing under the title until the names arrive, which is a moment. */}
            <MenuRadioGroup
              value={dictation.microphoneId}
              onValueChange={dictation.onChooseMicrophone}
            >
              {dictation.microphones.map((microphone) => (
                <MenuRadioItem key={microphone.id} value={microphone.id}>
                  {microphone.label}
                </MenuRadioItem>
              ))}
            </MenuRadioGroup>
          </MenuGroup>
        </MenuContent>
      </Menu>
    </div>
  );
}
